import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@api/services/api/api.service';
import {
  ApiParams,
  IdentificationVerifyDTO,
  ChannelDTO,
  ChecklistDTO,
  IdentificationStartRequestDTO,
  IdentificationStartDTO,
  OcrScanDTO,
  OcrCheckDTO
} from '@core/modules/api/models';
import { OutputAdapterService } from '@core/modules/api/services/output-adapter/output-adapter.service';
import { InputAdapterService } from '@core/modules/api/services/input-adapter/input-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCustomService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected outputAdapter: OutputAdapterService,
    protected inputAdapter: InputAdapterService
  ) {
    super(http, outputAdapter, inputAdapter);
  }

  getChecklist(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<ChecklistDTO> {
    if (params.options && params.options.params instanceof HttpParams) {
      params.options.params = params.options.params.delete('calculate');
    }

    return super.getChecklist(params);
  }

  postIdentificationStart(
    params: ApiParams<{ method: string }, IdentificationStartRequestDTO>
  ): Observable<IdentificationStartDTO> {
    const url = `${this.apiUrl}/v1/identification/${params.pathParams.method}/start`;

    return this.http
      .post<IdentificationStartDTO>(
        url,
        this.inputAdapter.postIdentificationStart(params).body,
        this.inputAdapter.postIdentificationStart(params).options
      )
      .pipe(map(res => this.outputAdapter.postIdentificationStart(res)));
  }

  getIdentificationVerify(
    params: ApiParams<{ method: string }, void>
  ): Observable<IdentificationVerifyDTO> {
    const url = `${this.apiUrl}/v1/identification/${params.pathParams.method}/verify`;

    return this.http.get<IdentificationVerifyDTO>(
      url,
      this.inputAdapter.getIdentificationVerify(params).options
    );
  }

  getChecklistDocumentScan(
    params: ApiParams<{ positionId: string; docId: string }, void>
  ): Observable<OcrScanDTO> {
    return of({
      outcome: 'OK'
    });
  }

  putChecklistDocumentOverride(
    params: ApiParams<
      { positionId: string; docId: string; fileId: string },
      FormData
    >
  ): Observable<number> {
    return this.postChecklistDocumentUpload(params);
  }

  getChecklistDocumentCheckOcr(
    params: ApiParams<{ positionId: string; docId: string }, void>
  ): Observable<OcrCheckDTO> {
    // eslint-disable-next-line max-len
    const url = `${this.apiUrl}/v1/positions/${params.pathParams.positionId}/checklists/current/documents/${params.pathParams.docId}/check`;

    return this.http
      .put<OcrCheckDTO>(
        url,
        {},
        this.inputAdapter.getChecklistDocumentCheckOcr(params).options
      )
      .pipe(map(res => this.outputAdapter.getChecklistDocumentCheckOcr(res)));
  }

  getChannel(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<ChannelDTO> {
    return of(null);
  }
}
